import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Order P |||| Order P records',
      orderM: 'M records',
      ordersPool: 'Pools',
      fields: {
        id: 'ID',
      },
    }
  }
}